import * as React from 'react';
import { Redirect } from 'react-router-dom';
import * as $ from 'jquery';
import * as classNames from 'classnames';
import Loader from '../../shared/loader';
import { pick, isEmpty } from 'lodash';
import colors from '../../shared/colors';

export default class extends React.Component<
  { accounts; fetchAccounts; fetchAccount; updateAccount },
  {
    _id: string;
    name: string;
    color: string;
    balance: string;
    loading: boolean;
    redirect: boolean;
  }
> {
  constructor(props) {
    super(props);
    const { search } = props.location;
    let account = {} as any;
    if (search) {
      const _id = new URLSearchParams(search).get('_id');
      props.fetchAccount(_id);
      account = (props.accounts && props.accounts[_id]) || {};
    }
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      ...this.state,
      _id: account._id,
      color: account.color || 'white',
      balance: account.balance,
      name: account.name
    };
  }

  componentDidUpdate() {
    $('select').material_select();
  }

  initialize(nextProps) {
    const { search } = nextProps.location;
    let account: any = {};
    if (search) {
      const _id = new URLSearchParams(search).get('_id');
      account = (nextProps.accounts && nextProps.accounts[_id]) || {};
    }
    this.setState({
      ...this.state,
      _id: account._id,
      color: account.color || 'white',
      name: account.name,
      balance: account.balance
    });
  }

  componentWillReceiveProps(nextProps) {
    this.initialize(nextProps);
  }

  handleChange(el) {
    return event => {
      this.setState({ [el]: event.target.value } as any);
    };
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });
    const model = pick(this.state, ['_id', 'color', 'balance', 'name']);
    await this.props.updateAccount(model);
    this.setState({ redirect: true });
  }

  addColor(color) {
    const className = classNames('inline-block', {
      ['indigo lighten-5']: this.state.color === color
    });
    const colorClassName = classNames('color', color);
    const textColor = classNames(colors[color]);
    return (
      <div className={className}>
        <a
          href="#"
          onClick={event => {
            event.preventDefault();
            this.setState({ color: color });
          }}
        >
          <span className={colorClassName}>
            <label className={textColor}>{color}</label>
          </span>
        </a>
      </div>
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/dashboard" />;
    }
    if (this.state.loading) {
      return <Loader />;
    }
    return (
      <div className="addAccount">
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col s2" />
            <div className="input-field col s8">
              <label className={classNames({ active: !!this.state.balance })} htmlFor="value">
                Balance
              </label>
              <input
                id="value"
                type="number"
                required
                className="validate"
                value={this.state.balance}
                onChange={this.handleChange('balance')}
              />
            </div>
            <div className=" col s2" />
          </div>

          <div className="row">
            <div className="col s2" />
            <div className="input-field col s8">
              <label className={classNames({ active: !!this.state.name })} htmlFor="name">
                Name
              </label>
              <input
                id="name"
                type="text"
                required
                className="validate"
                value={this.state.name}
                onChange={this.handleChange('name')}
              />
            </div>
            <div className=" col s2" />
          </div>

          <div className="color">
            <div className="row">
              <div className="col s2" />
              <label>Color</label>
            </div>

            <div className="row">
              <div className="col s2" />
              <div className="col s10">
                {this.addColor('white')}
                {this.addColor('black')}
                {this.addColor('yellow')}
                {this.addColor('blue')}
                {this.addColor('green')}
                {this.addColor('purple')}
                {this.addColor('red')}
              </div>
            </div>
          </div>

          <div className="fixed-action-btn">
            <div className="center-align">
              <button type="submit" className="btn-floating btn-large waves-effect waves-light light-blue darken-3">
                <i className="material-icons">done</i>
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/accounts/update-account/component.tsx